<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import LayoutDefault from './layouts/LayoutDefault.vue'
import LayoutDashboard from './layouts/LayoutDashboard.vue'

export default {
  name: 'App',
  components: {
    'layout-default': LayoutDefault,
    'layout-dashboard': LayoutDashboard
  },
  setup() {
    const route = useRoute()
    
    const layout = computed(() => {
      return "layout-" + (route.meta.layout || "default").toLowerCase()
    })
    
    return {
      layout
    }
  }
}
</script>

<style lang="scss">
@import './scss/app.scss';
</style>